
import { CostSupplementEnum } from "./enum"
import {timeRangeOptions} from "@/utils/options";

export default () => [{
    prop: 'name',
    label: '视图名称',
    isFormItem: true,
    components() {
        return [{
            name: 'gj-input',
            prop: 'name',
            propsData: {
                placeholder: '请输入视图名称',
                style: {
                    width: '256px'
                }
            }
        }]
    },
    validator: [
        {required: true, message: '请输入视图名称', trigger: 'change'}
    ],
    labelWidth: '120px',
    defaultValue: ''
}, {
    label: '仓库',
    prop: 'warehouseIds',
    components: [{
        name: 'gj-warehouse-select',
        prop: 'warehouseIds',
        propsData: {
            placeholder: '仓库',
            fba: false,
            multiple: true
        },
        style: {
            width: '150px'
        }
    }],
    isFormItem: true,
    labelWidth: '120px',
    defaultValue: []
}, {
    label: '全部类型',
    prop: 'costType',
    components: [{
        name: 'gj-select',
        prop: 'costType',
        propsData: {
            placeholder: '全部类型',
            options: CostSupplementEnum.costTypeOption
        },
        style: {
            width: '150px'
        }
    }],
    isFormItem: true,
    labelWidth: '120px',
    defaultValue: ''
}, {
    label: '状态',
    prop: 'status',
    components: [{
        name: 'gj-select',
        prop: 'status',
        propsData: {
            placeholder: '状态',
            options: CostSupplementEnum.statusOption
        },
        style: {
            width: '120px'
        }
    }],
    isFormItem: true,
    labelWidth: '120px',
    defaultValue: ''
}, {
    label: '时间范围',
    prop: 'dateRange',
    isFormItem: true,
    labelWidth: '120px',
    components: [ {
        name: 'gj-select',
        prop: 'dateRange',
        propsData: {
            placeholder: '时间范围',
            options: timeRangeOptions,
            style: {
                marginLeft: '8px'
            }
        }
    }],
    validator: [
        {required: true, message: '请选择日期', trigger: 'change'}
    ]
}]
